import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { SecurityData } from './security-data';
import { AppConfigService } from '../core/services/app-config.service';

export const canActivateKanton: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean> | Promise<boolean> | boolean => {
  return new Promise<boolean>((resolve) => {
    const kanton: string[] = route.data.kanton;
    const appConfigService = inject(AppConfigService);
    if (kanton && !kanton.some((e) => appConfigService.kanton.includes(e))) {
      const securityData = inject(SecurityData);
      const router = inject(Router);
      securityData.actionUrl = state.url;
      securityData.kanton = kanton;
      router.navigate(['security/unsupported']);
      resolve(false);
    }
    resolve(true);
  });
};
